import makeStyles from '@mui/styles/makeStyles'
import clsx from 'clsx'
import { motion } from 'framer-motion'
import { Paper } from '@components'
import { FavoriteDatasets } from './favoriteDatasets'
import { RecentDatasets } from './recentDatasets'
import { RecentSubmissions } from './recentSubmissions'
import { Reports } from './reports'

const useStyles = makeStyles(theme => ({
  holder: {
    height: '100%',
    overflow: 'scroll',
  },
  paper: {
    boxShadow: '0 5px 8px rgba(0, 0, 0, 0.05)',
    border: '1px solid #e9e9e9',
    borderRadius: 6,
    height: '100%',
  },
  half: {
    flex: 1,
    maxWidth: '50%',
  },
  full: {
    width: '100%',
  },
  row: {
    display: 'flex',
    gap: '25px',
    flexWrap: 'wrap',
  },
  submissions: {
    marginBottom: theme.spacing(3),
  },
}))

const DashboardWidget = ({ children, className, delay }) => {
  const classes = useStyles()

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{
        opacity: 1,
        y: 0,
        transition: { duration: 0.5, delay, ease: 'easeOut' },
      }}
      className={className}
    >
      <Paper elevation={3} className={clsx(classes.paper)}>
        {children}
      </Paper>
    </motion.div>
  )
}

export const Home = () => {
  const classes = useStyles()

  return (
    <motion.div
      className={classes.holder}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.25, ease: 'easeInOut' } }}
      exit={{ opacity: 0, transition: { duration: 0.25, ease: 'easeInOut' } }}
    >
      <Reports />
      <div style={{ padding: 25 }} data-test-page-id="home">
        <div className={classes.row}>
          <DashboardWidget className={clsx(classes.half)} delay={0.05}>
            <RecentDatasets />
          </DashboardWidget>
          <DashboardWidget className={clsx(classes.half)} delay={0.2}>
            <FavoriteDatasets />
          </DashboardWidget>
          <DashboardWidget className={clsx(classes.full)} delay={0.4}>
            <RecentSubmissions />
          </DashboardWidget>
        </div>
      </div>
    </motion.div>
  )
}
